import { PrivateOfficePasswordForm } from '../../PrivateOfficePasswordForm/PrivateOfficePasswordForm';

import styles from './PropertyLockedPasswordCard.module.css';

export const PropertyLockedPasswordCard = (): React.ReactElement => {
  return (
    <div className={styles.container} data-testid="property-locked-password-card" onClick={(e) => e.stopPropagation()}>
      <PrivateOfficePasswordForm />
    </div>
  );
};
